export default __webpack_public_path__ + "static/media/training2.c61262de.jpg";